import React from "react";
import validator from "validator";

const setError = (valor) => {
  return <span style={{ color: "red" }}> {valor}</span>;
};

export const required = (value) => {
  if (!value.toString().trim().length) {
    // We can return string or jsx as the 'error' prop for the validated Component
    return setError("Campo requerido");
  }
};

export const email = (value) => {
  if (!validator.isEmail(value)) {
    return setError(`${value} no es un correo válido.`);
  }
};

/*export const lt = (value, props) => {
  // get the maxLength from component's props
  if (!value.toString().trim().length > props.maxLength) {
    // Return jsx
    return (
      <span className="error">
        The value exceeded {props.maxLength} symbols.
      </span>
    );
  }
};
*/

export const password = (value, props, components) => {
  if (
    components["nuevacontrasena"][0].value !==
    components["rnuevacontrasena"][0].value
  ) {
    return setError("Las contraseñas deben ser iguales");
  }
};

export const password1 = (value, props, components) => {
  if (Object.keys(components["password"][0].value).length < 6) {
    return setError("Las contraseñas deben tener almenos 6 caracteres.");
  }
};
export const nombres = (value) => {
  value = value.replace(/ /g, "");
  value = value.split(".").join("");
  if (!validator.isAlpha(value, "es-ES")) {
    return setError(`El valor tiene carateres no válidos.`);
  }
};

export const telefono = (value) => {
  if (!validator.isNumeric(value)) {
    return setError(`El valor debe ser numérico.`);
  }
  if (value.length < 7) {
    return setError(`El valor debe tener minimo 7 números`);
  }
  return "";
};

export const cedula = (value) => {
  if (!validator.isNumeric(value)) {
    return setError(`El valor debe ser numérico.`);
  }
  if (value.length < 10) {
    return setError(`El valor debe tener minimo 10 números`);
  }
  return "";
};

/**
 *
 * @param {*} value valor a validar
 * @returns Validación para comprobar si un string contiene un número
 */
export const esNumero = (value) => {
  if (typeof value != "string") return false;
  return !isNaN(value) && !isNaN(parseFloat(value));
};

/**
 * Obtiene el primer número de un string de números separados por coma.
 * @param {string} str - El string de entrada.
 * @returns {string} El primer número del string.
 */
export const getFirstNumber = (str) => {
  // Validamos si el string está vacío
  if (!str || str === "") {
    return "";
  }
  // Dividimos el string por la coma y obtenemos el primer elemento
  const first = str.split(",")[0];

  // Usamos una expresión regular para eliminar todo lo que no sea un dígito
  return first.replace(/\D/g, "");
};

export const generarParametrosUrl = (datos) => {
  const parametros = [];

  for (const clave in datos) {
    if (datos.hasOwnProperty(clave)) {
      const valor = datos[clave];
      const parametro =
        encodeURIComponent(clave) + "=" + encodeURIComponent(valor);
      parametros.push(parametro);
    }
  }

  return parametros.join("&");
};

export const obtenerColor = (index) => {
  switch (index) {
    case 0:
      return '#4EA3DE'
    case 1:
      return '#BC95E8'
    default:
      return '#001871'
      break;
  }
}


export const obtenerDatosHogar = (codigoProductoEspecial) => {
  let datosHogar = {
    ramo: "Hogar",
    codigoEspecial: "hogar",
    titulo: "Cotización de Hogar Protección Total",
    producto: "PLAN ABIERTO",
    codigo: null
  };

  switch (codigoProductoEspecial) {
    case "advance":
      datosHogar.ramo = "Hogar Advance";
      datosHogar.codigoEspecial = "hogar-advance";
      datosHogar.titulo = "Cotización de Hogar Advance";
      datosHogar.producto = "HOGAR ADVANCE";
      datosHogar.codigo = codigoProductoEspecial

      break;

    case "hogar-aig":
      datosHogar.ramo = "Hogar";
      datosHogar.codigoEspecial = "hogar";
      datosHogar.titulo = "Cotización de Hogar AIG";
      datosHogar.producto = "HOGAR AIG";
      datosHogar.codigo = codigoProductoEspecial
      break;

    default:
      break;
  }

  return datosHogar;
};

/**
 * Comprueba si el número de cédula ingresado es valido.
 * @param  {string|integer}  ci Número de cédula
 * @return {Boolean}
 */
export const isValidCI = (ci) => {
  var isNumeric = true;
  var total = 0,
    individual;

  for (var position = 0; position < 10; position++) {
    // Obtiene cada posición del número de cédula
    // Se convierte a string en caso de que 'ci' sea un valor numérico
    individual = ci.toString().substring(position, position + 1)

    if (isNaN(individual)) {
      console.log(ci, position, individual, isNaN(individual))
      isNumeric = false;
      break;
    } else {
      // Si la posición es menor a 9
      if (position < 9) {
        // Si la posición es par, osea 0, 2, 4, 6, 8.
        if (position % 2 == 0) {
          // Si el número individual de la cédula es mayor a 5
          if (parseInt(individual) * 2 > 9) {
            // Se duplica el valor, se obtiene la parte decimal y se aumenta uno 
            // y se lo suma al total
            total += 1 + ((parseInt(individual) * 2) % 10);
          } else {
            // Si el número individual de la cédula es menor que 5 solo se lo duplica
            // y se lo suma al total
            total += parseInt(individual) * 2;
          }
          // Si la posición es impar (1, 3, 5, 7)
        } else {
          // Se suma el número individual de la cédula al total
          total += parseInt(individual);
        }
      }
    }
  }

  if ((total % 10) != 0) {
    total = (total - (total % 10) + 10) - total;
  } else {
    total = 0;
  }


  if (isNumeric) {
    // El total debe ser igual al último número de la cédula
    console.log(ci, total, individual);
    console.log(ci, typeof ci, ci.length)
    // La cédula debe contener al menos 10 dígitos
    if (ci.toString().length != 10) {
      return false;
    }

    // El número de cédula no debe ser cero
    if (parseInt(ci, 10) == 0) {
      return false;
    }

    // El total debe ser igual al último número de la cédula
    if (total != parseInt(individual)) {
      return false;
    }

    console.log('cédula válida', ci);
    return true;
  }

  // Si no es un número  
  return false;
}

export const isValidNombreEC = (nombre) => {
  if (!nombre) return false;

  const regex = /^[A-Za-zÁÉÍÓÚáéíóúÑñ]+(?:\s[A-Za-zÁÉÍÓÚáéíóúÑñ]+)*$/;

  // quitar espacios de más
  const limpio = nombre.trim();

  if (limpio.length < 2) {
    return false;
  }

  if (!regex.test(limpio)) {
    return false;
  }

  return true;
}


export const isTrue = (value) => {
  if (value === null || value === undefined) return false;

  if (typeof value === 'boolean') return value;

  if (typeof value === 'number') return value === 1;

  if (typeof value === 'string') {
    return ['true', 'verdadero', '1', 'yes', 'sí'].includes(value.toLowerCase().trim());
  }

  return false;
};